export const openLink = (link, openTab) => {
  window.open(link, openTab);
};
